// extracted by mini-css-extract-plugin
export default {"txt":"Map_txt__mVqjm","marker":"Map_marker__7e8zI"};